<template>
  <div class="text-left">
    <h6 class="text-dark"><i class="el-icon-menu" style="color: #909399"></i> Dashboard</h6>
    <div class="mt-5"  v-if="isUserRoot">
      <el-row :gutter="6" style="display: flex; vertical-align: top;flex-wrap: wrap;">
        <dashComp v-for="(comp, key) in dashCompsProps" :key="key" :span="spanSize" :data="comp"></dashComp>
      </el-row>
    </div>
  </div>
</template>

<script>
  import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
  export default {
    components: {
      dashComp: () => import('./DashComp')
    },
    mixins: [ fieldController],
    data () {
      return {
        dashCompsProps: [
          {
            title: 'Users',
            icon: 'el-icon-user',
            apiStore: 'user-api',
            action: () => { $router.push({name: 'module->user->list->page', props: {listPage: 1}})},
            actionLabel: 'Open'
          },
          {
            title: 'Vendors',
            icon: 'el-icon-user-solid',
            apiStore: 'voip-vendor-api',
            action: () => { $router.push({name: 'module->voip-vendor->list->page', props: {listPage: 1}})},
            actionLabel: 'Open'
          },
          {
            title: 'Rates',
            icon: 'el-icon-tickets',
            apiStore: 'voip-vendor-api',
            apiAction: 'rateDashboardInfo',
            action: () => { $router.push({name: 'module->voip-vendor->list->page', props: {listPage: 1}})},
            actionLabel: 'Open'
          },
          {
            title: 'Testing Numbers',
            icon: 'el-icon-sort',
            apiStore: 'voip-testing-numbers-api',
            action: () => { $router.push({name: 'module->voip-testing-numbers->list->page', props: {listPage: 1}})},
            actionLabel: 'Open'
          },
          {
            title: 'DialPlan',
            icon: 'el-icon-c-scale-to-original\n',
            apiStore: 'voip-dialplan-api',
            action: () => { $router.push({name: 'module->voip-dialplan->list->page', props: {listPage: 1}})},
            actionLabel: 'Open'
          },
          {
            title: 'Rates Divisions',
            icon: 'el-icon-s-grid',
            apiStore: 'voip-rate-division-api',
            action: () => { $router.push({name: 'module->voip-rate-division->list->page', props: {listPage: 1}})},
            actionLabel: 'Open'
          },
          {
            title: 'Network Servers',
            icon: 'el-icon-bank-card',
            apiStore: 'network-server-api',
            action: () => { $router.push({name: 'module->network-server->list->page', props: {listPage: 1}})},
            actionLabel: 'Open'
          },
          {
            title: 'Fusion Servers',
            icon: 'el-icon-bank-card',
            apiStore: 'voip-fusion-server-api',
            action: () => { $router.push({name: 'module->voip-fusion-server->list->page', props: {listPage: 1}})},
            actionLabel: 'Open'
          },
          {
            title: 'SIP Dialer',
            icon: 'el-icon-phone-outline',
            apiStore: 'voip-sip-dialer-api',
            action: () => { $router.push({name: 'module->voip-sip-dialer->list->page', props: {listPage: 1}})},
            actionLabel: 'Open'
          },
        ],
        spanSize: 6,
        isUserRoot: $store.getters['user-state/isUserRoot'],
        control: this,
        dataModel: {
          location: 'fff'
        }
      }
    }

  }
</script>
